import React from 'react';

import classes from './Modal.scss';

type Props = Record<string, unknown>;

export const ModalBody: React.FC<React.PropsWithChildren> = (props) => {
    return <div className={classes.modalBody}>{props.children}</div>;
};
